// src/hooks/useUserItems.js
import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from './useAuth';

export const useUserItems = () => {
    const { profile } = useAuth();
    const [userItems, setUserItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!profile) {
            setUserItems([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        const q = query(collection(db, "items"), where("ownerId", "==", profile.id));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const itemsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setUserItems(itemsData);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching user items:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [profile]);

    return { userItems, loading };
};
